import { useSelector } from "react-redux"

import { StoreType } from "client/store"
import { TableColumn } from "client/components"

const Columns = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const columns: TableColumn[] = [
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "300px",
        },
        {
            field: "description",
            header: lang.description,
        },
        {
            field: "order",
            header: lang.order,
            sortable: true,
            cellMinWidth: "100px",
        },
        {
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        },
    ]

    return columns
}
export default Columns
